import { gql } from 'graphql-request';
import { request } from '../graphql';

export const GET_MY_DASHBOARDS = gql`
  query profile {
    getMyProfile {
      company {
        _id
        homeDashboard
        realTimeSequenceOfDashboard {
          dashboardTabs {
            dashboardId
            title
            order
          }
        }
        dashboards {
          _id
          order
          title
          reckonings {
            _id
            endDate
          }
          sequenceOfDashboard {
            title
            tagColor
            tagName
            dashboardTabs {
              dashboardId
              title
              order
              addBelowFive5Plot
              suveyFor5APlot {
                _id
              }
            }
          }
        }
        realTimeDashboardSummary
        realTimeDashboardUsage
        realTimeDashboardFeature
        realTimeDashboardSegment
      }
    }
  }
`;

export type GetMyDashboardsData = {
  getMyProfile: {
    company: {
      _id: string;
      homeDashboard:string;
      realTimeSequenceOfDashboard: {
        dashboardTabs: {
          dashboardId: string;
          title: string;
          order: number;
          addBelowFive5Plot?: boolean;
          suveyFor5APlot?: {
           _id: string;
          };
        }[]
      }
      dashboards: {
        _id: string;
        order: number;
        title:string;
        reckonings: {
          _id: string;
          endDate: string,
        }[]
        sequenceOfDashboard: {
          tagColor: string;
          tagName: string;
          title: string;
          dashboardTabs: {
            dashboardId: string;
            title: string;
            order: number;
            addBelowFive5Plot?: boolean;
            suveyFor5APlot?: {
              _id: string;
            };
          }[]
        }
      }[]
    }
  }
}

export const getMyDashboards = (language: string) => request<GetMyDashboardsData>(GET_MY_DASHBOARDS, {}, language);
